import BasePage from '../../components/base-page/base-page';
import './educational-discount.scss';

class EducationalPage extends BasePage {
  ui = {
    promoAppsSection: '.js-promo-apps-section',
    promoAppsSelect: '.js-promo-apps-select',
  };

  uiCollections = {
    promoAppsCollections: '.js-promo-apps-collection',
    promoAppsRadioSwitchers: '.js-promo-apps-radio-switcher',
  };

  events = {
    'click @uiCollections.promoAppsRadioSwitchers': 'handlePromoAppCollectionSelect',
    'change @ui.promoAppsSelect': 'handlePromoAppCollectionSelect',
  };

  handlePromoAppCollectionSelect(e) {
    this.selectActivePromoCollection(e.currentTarget.value);
  }

  selectActivePromoCollection(collectionName) {
    // keep radio buttons and select in sync
    this.ui.promoAppsSelect.value = collectionName;
    this.uiCollections.promoAppsRadioSwitchers.forEach((radioButton) => {
      // eslint-disable-next-line no-param-reassign
      radioButton.checked = radioButton.value === collectionName;
    });

    this.uiCollections.promoAppsCollections.forEach(
      (collection) => collection.classList
        .toggle('d-none', collection.dataset.collection !== collectionName)
    );
  }
}

export default EducationalPage;

EducationalPage.initOnDomLoaded();
